import { AuctionEntity } from '@eastcoal/api/trade/interface'

import { BizType } from '../enums/BizType'

/**
 * 使用邀约 id 后 6 位作为席位号
 */
export const getSeatNo = (applyId: string) => {
  return applyId.slice(-6)
}

export type GetAuctionPriceInfoResult = {
  label?: string
  value?: number
  allowLabel?: string
  allowValue?: boolean
  allowValueText?: string
}

/**
 * 获取价格信息（限价或者是起拍价）
 */
export const getAuctionPriceInfo = ({
  bizType,
  startPrice,
  limitPrice,
  allowStartPrice,
  allowLimitPrice
}: Pick<
  AuctionEntity,
  | 'bizType'
  | 'startPrice'
  | 'limitPrice'
  | 'allowStartPrice'
  | 'allowLimitPrice'
>): GetAuctionPriceInfoResult => {
  const showLimitPrice =
    bizType === BizType.INQUIRY_AUCTION || bizType === BizType.TENDER_AUCTION

  return showLimitPrice
    ? {
        label: '限价',
        value: limitPrice,
        allowLabel: '是否允许限价',
        allowValue: allowLimitPrice,
        allowValueText: allowLimitPrice ? '是' : '否'
      }
    : {
        label: '起拍价',
        value: startPrice,
        allowLabel: '是否允许起拍价',
        allowValue: allowStartPrice,
        allowValueText: allowStartPrice ? '是' : '否'
      }
}

/**
 * 是否为委托方
 */
export const isEntrust = (bizType?: string | number, isSale?: boolean) => {
  switch (bizType) {
    case BizType.TRADITION_AUCTION:
    case BizType.RANKING_AUCTION:
    case BizType.HOUSE_AUCTION:
    case BizType.SECRET_AUCTION:
    case BizType.LISTING:
    case BizType.PRICE_CUT_AUCTION:
      return !isSale
    case BizType.INQUIRY_AUCTION:
    case BizType.TENDER_AUCTION:
    case BizType.PRICE_COMPARE:
      return isSale
    default:
      return false
  }
}

/**
 * 地址管理模块中“淮北矿业”项的编码
 */
export const AREA_CODE_HBCOAL = '0101070401'
